module.exports = __webpack_public_path__ + "static/media/play_btn.4f2849c1.png";